/**
 * @generated SignedSource<<25fd2cb3c1f2361a877c156340818318>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusWidgetHasAccessQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetDailyPulseQuery" | "plusWidgetHighlightsQuery" | "plusWidgetNewsAgendaQuery">;
  readonly " $fragmentType": "plusWidgetHasAccessQuery";
};
export type plusWidgetHasAccessQuery$key = {
  readonly " $data"?: plusWidgetHasAccessQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusWidgetHasAccessQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dailyPulseTypeUuId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "highlightQueueName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaEndDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaStartDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plusNewsAgendaTypes"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusWidgetHasAccessQuery",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "dailyPulseTypeUuId",
          "variableName": "dailyPulseTypeUuId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetDailyPulseQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "queueName",
          "variableName": "highlightQueueName"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetHighlightsQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "applicationId",
          "variableName": "applicationId"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaEndDate",
          "variableName": "plusNewsAgendaEndDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaStartDate",
          "variableName": "plusNewsAgendaStartDate"
        },
        {
          "kind": "Variable",
          "name": "plusNewsAgendaTypes",
          "variableName": "plusNewsAgendaTypes"
        }
      ],
      "kind": "FragmentSpread",
      "name": "plusWidgetNewsAgendaQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "df64a819362bcb0093b76e73f45b0c40";

export default node;
